var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDanger(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.42773 8.96791C6.8597 4.65597 8.07568 2.5 10.0013 2.5C11.9269 2.5 13.1429 4.65597 15.5749 8.96791L15.8779 9.50522C17.8989 13.0884 18.9093 14.88 17.9961 16.19C17.0828 17.5 14.8233 17.5 10.3044 17.5H9.69825C5.17927 17.5 2.91978 17.5 2.00652 16.19C1.09325 14.88 2.10373 13.0884 4.12468 9.50523L4.42773 8.96791ZM10.0013 6.04167C10.3465 6.04167 10.6263 6.32149 10.6263 6.66667V10.8333C10.6263 11.1785 10.3465 11.4583 10.0013 11.4583C9.65612 11.4583 9.3763 11.1785 9.3763 10.8333V6.66667C9.3763 6.32149 9.65612 6.04167 10.0013 6.04167ZM10.0013 14.1667C10.4615 14.1667 10.8346 13.7936 10.8346 13.3333C10.8346 12.8731 10.4615 12.5 10.0013 12.5C9.54106 12.5 9.16797 12.8731 9.16797 13.3333C9.16797 13.7936 9.54106 14.1667 10.0013 14.1667Z",
    fill: "#FF393C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/danger.a1cda9a20135fb793ca2216fa3a59213.svg";
export { ForwardRef as ReactComponent };